import { defineStore } from "pinia";
import { ref } from "vue";
import { IHoldSummary } from "@crm-ui/types";
import { IOfferV2 } from "@/api/types/offers";

export type HoldSingleFiltersPayload = Record<string, any>;

export const useHoldSingleStore = defineStore("useHoldSingleStore", () => {
    const filters = ref<HoldSingleFiltersPayload>({});
    const totals = ref<IHoldSummary[]>([]);
    const offer = ref<IOfferV2 | null>(null);

    const updateFilters = (data: HoldSingleFiltersPayload) => {
        filters.value = { ...data };
    };

    const updateTotals = (data: IHoldSummary[]) => {
        totals.value = data;
    };

    const updateOffer = (data: IOfferV2 | null) => {
        offer.value = data;
    };

    return { filters, updateFilters, totals, updateTotals, offer, updateOffer };
});
